import React from "react";

const Step15Line = ({ className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="2"
      viewBox="0 0 22 2"
      fill="none"
      className={className}
    >
      <path d="M0 1H22" stroke="url(#paint0_linear_1115_1171)" />
      <defs>
        <linearGradient
          id="paint0_linear_1115_1171"
          x1="0"
          y1="1.5"
          x2="22"
          y2="1.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A2134" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Step15Line;
